import axios from "axios";
import {

} from "../slices/querySlices";
import { mainurl } from "./mainurl";
import { contactRequest, contactSuccess } from "../slices/contactSlice";


const baseurl = mainurl;

export const getContactData = async (dispatch) => {
    try {
        dispatch(contactRequest());
        const { data } = await axios.get(`${baseurl}/contact/getcontact`, {
            withCredentials: true,
        });
        dispatch(contactSuccess(data));
    } catch (error) {
        console.log(error);
    }
};

